export default class wdkDialogTrigger extends HTMLElement {
	#abortController = null;
	#dialogId = null;

	async connectedCallback() {
		this.#abortController = new AbortController();
		this.#dialogId = this.getAttribute('dialog-id');
		await jPar.util.waitForChildNodes();

		this.addEventListener(
			'click',
			() => {
				document.querySelector('#' + this.#dialogId).openModal();
				this.trackClick();
			},
			{ signal: this.#abortController.signal },
		);
	}

	trackClick() {
		const configTemplate = this.querySelector('template[data-tracking]');
		if (configTemplate !== null) {
			let trackingConfig = {};

			try {
				const configText = configTemplate.content.textContent.trim();
				trackingConfig = JSON.parse(configText).tracking;

				const trackingData = {
					category: trackingConfig.category || '',
					subcategory: trackingConfig.subcategory || '',
					targetId: trackingConfig.targetId || '',
					action: trackingConfig.action || 'click',
				};

				['cd1', 'cd2', 'cd3', 'cd4', 'cd5', 'cd6'].forEach((key) => {
					if (trackingConfig[key] && trackingConfig[key].trim()) {
						trackingData[key] = trackingConfig[key];
					}
				});

				jPar.util.log.bigData(trackingData);
			} catch (e) {
				console.error('Fehler beim Parsen der JSON Tracking-Konfiguration aus dem Template', e);
			}
		}
	}

	async disconnectedCallback() {
		this.#abortController?.abort();
	}
}
